import React from "react";
import Logo from "../../../containers/assets/LandingPageLogo3.png";

function TeamReportsTableContentsLayout({
  title = "",
  left_content = "",
  right_content = ""
}) {
  return (
    <div className="team-reports-layout table-contents">
      <div className="team-reports-logo without-border">
        <img src={Logo} alt="logo" />
        <div className="orange-line" />
        <div className="green-line" />
      </div>
      <div className="title">{title}</div>
      <div className="table-contents-inner-content clearfix">
        <div className="left">{left_content}</div>
        <div className="right">{right_content}</div>
      </div>
    </div>
  );
}

export default TeamReportsTableContentsLayout;



// WEBPACK FOOTER //
// ./src/components/team-reports/layouts/table-contents.js